function appendHiddenFields(
    form: HTMLFormElement,
    data: Record<string, string>
) {
    for (const [key, value] of Object.entries(data)) {
        const field = document.createElement("input")
        field.value = value
        field.hidden = true
        field.name = key
        form.appendChild(field)
    }
}

function onSubmitInvoke(this: HTMLButtonElement, evt) {
    evt.preventDefault()

    const extraData: Record<string, string> = {}

    const source = evt.currentTarget
    const data = source.dataset

    const targetForm = document.getElementById(data.submit) as HTMLFormElement
    if (targetForm == null)
        throw new Error(`Form with id ${data.submit} not found`)

    const captchaData = document.getElementById("captcha-script").dataset

    // Take name & value from submit button
    if (this.hasAttribute("name") && this.hasAttribute("value")) {
        extraData[this.getAttribute("name")] = this.getAttribute("value")
    }

    grecaptcha.ready(() => {
        grecaptcha
            .execute(captchaData.sitekey, { action: data.action })
            .then((token) => {
                extraData["RecaptchaToken"] = token
                appendHiddenFields(targetForm, extraData)
                targetForm.submit()
            })
    })
}

document
    .querySelectorAll("[data-submit]")
    .forEach((e) => e.addEventListener("click", onSubmitInvoke))
